import React from "react";
import { Link } from "react-router-dom";

export default function Manifesto() {
  return (
    <div data-testid="manifesto-page">
      <section className="bg-oc-ink text-white relative overflow-hidden">
        <img
          src="/oc-mark.png"
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute -right-16 -top-10 md:-right-8 md:-top-6 w-64 md:w-80 opacity-[0.08]"
        />
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-20 md:py-32 relative">
          <div className="eyebrow text-oc-coral mb-8">Manifesto</div>
          <h1 className="font-editorial text-4xl md:text-6xl leading-[1.05] max-w-3xl">
            Most valuable operational knowledge is never properly documented.
          </h1>
        </div>
      </section>
      <section className="max-w-reading mx-auto px-6 md:px-0 py-20 md:py-28">
        <div className="prose-editorial">
          <p className="text-2xl md:text-[1.6rem] leading-snug">
            It lives in private conversations, in years of hard experience, and in decisions made under pressure. It sits in the head of the general manager who has closed three restaurants and opened five. It sits in the estimator who has bid ten thousand jobs. It sits in the accountant who has watched a firm survive two recessions.
          </p>
          <p>
            When those people retire, or move on, or die, the knowledge goes with them. That has always been true. It should not continue to be.
          </p>
          <blockquote className="pull-quote">
            Operating Class exists to preserve that knowledge, organize it, and make it available.
          </blockquote>
          <p>
            We are not a business news site. We are not a podcast network. We are not a content company. We are a publication in the classical sense, an editorial institution designed to make the accumulated operating wisdom of a generation of company builders accessible to the next generation.
          </p>
          <p>
            We publish long-form interviews. We build a searchable archive. We connect topics across industries so that a construction operator can learn from a restaurant operator, and a family-business heir can learn from a bootstrapped software CEO. We treat the interview as a document, not a moment. It should be as useful in ten years as it is on the day it is published.
          </p>
          <p>
            We believe operating is a craft. We believe the craft is worth taking seriously. We believe that most of what passes for business content today does not take it seriously enough. We are building a place that does.
          </p>
        </div>
        <div className="mt-16 text-center">
          <Link to="/contribute" className="inline-flex items-center h-14 px-8 bg-oc-coral text-white font-ui text-sm font-bold uppercase tracking-widest hover:bg-oc-coral-hover">
            Contribute an interview
          </Link>
        </div>
      </section>
    </div>
  );
}
